import {ValueObject} from '@s-ui/domain'

export class DatalistFormValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {DatalistItemFormValueObject<>} params.datalist
   * */
}
